import { z } from "zod";

/**
 * Common validation fragments that can be reused across schemas
 */

// Email validation with normalization
export const emailSchema = z
  .string({ message: "Email is required" })
  .email("Please enter a valid email address")
  .transform((email) => email.toLowerCase().trim());

// Name validation
export const nameSchema = z
  .string({ message: "Name is required" })
  .refine(
    (val) => val.trim().length >= 2,
    "Name must be at least 2 characters",
  );

// Basic password validation
export const basicPasswordSchema = z
  .string()
  .min(6, "Password must be at least 6 characters");

// Strong password validation
export const strongPasswordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[0-9]/, "Password must contain at least one number")
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(/[a-z]/, "Password must contain at least one lowercase letter");

// Super strong password with special characters
export const superStrongPasswordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
  );

// Boolean fields
export const activeSchema = z.boolean().default(true);
